 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import ACOVER from '@/components/1-cover'
 import EBADFRONT from '@/components/ebadfront'
 import PORTALISTAD from '@/components/portalistad'
 import LOVE_1 from '@/components/love_1'
 import ATITLE_PAGE from '@/components/2-title_page'
 import ADEDICATION from '@/components/3-dedication'
 import ATOC from '@/components/4-TOC'
 import ASTART from '@/components/5-start'
 import ACHAP1 from '@/components/6-chap1'
 import ACHAP2 from '@/components/7-chap2'
 import ACHAP3 from '@/components/8-chap3'
 import ACHAP4 from '@/components/9-chap4'
 import A0CHAP5 from '@/components/10-chap5'
 import A1CHAP6 from '@/components/11-chap6'
 import A2CHAP7 from '@/components/12-chap7'
 import A3CHAP8 from '@/components/13-chap8'
 import A4CHAP9 from '@/components/14-chap9'
 import A5CHAP10 from '@/components/15-chap10'
 import A6CHAP11 from '@/components/16-chap11'
 import A7CHAP12 from '@/components/17-chap12'
 import A8CHAP13 from '@/components/18-chap13'
 import A9CHAP14 from '@/components/19-chap14'
 import A0CHAP15 from '@/components/20-chap15'
 import A1CHAP16 from '@/components/21-chap16'
 import A2CHAP17 from '@/components/22-chap17'
 import A3CHAP18 from '@/components/23-chap18'
 import LOVE_2 from '@/components/love_2'
 import A4BIOGRAPHY from '@/components/24-biography'
 import A5COPYRIGHT from '@/components/25-copyright'
 import AUBA from '@/components/auba'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/4-TOC",
 			"name" : "4-TOC",
 			"component" : ATOC
 		},
 		{
 			"path" : "/5-start",
 			"name" : "5-start",
 			"component" : ASTART
 		},
 		{
 			"path" : "/6-chap1",
 			"name" : "6-chap1",
 			"component" : ACHAP1
 		},
 		{
 			"path" : "/7-chap2",
 			"name" : "7-chap2",
 			"component" : ACHAP2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js